import React, { useState } from 'react';
import './ThumbnailOverlayBadge.css';

export const ThumbnailOverlayBadge = ({
    badgeName,
    badgeText,
    onClickHandler,
    openToRight = true,
}) => {
    const [badgeDetailsVisible, setBadgeDetailsVisible] = useState(false);
    const badgeNameClass = `casino-thumbnail__hover-badge--${badgeName}`;

    const overlayClassNames = [
        'casino-thumbnail__hover-badge',
        badgeNameClass,
        `casino-thumbnail__hover-badge--${openToRight ? 'right' : 'left'}`,
    ];

    const initClassNames = [
        'casino-thumbnail__hover-badge-init',
        badgeNameClass,
    ];

    return (
        <>
            {!badgeDetailsVisible && <div
                className={initClassNames.join(' ')}
                onClick={onClickHandler}
            >
                <div
                    className="casino-thumbnail__hover-badge-icon"
                    onMouseEnter={() => {setBadgeDetailsVisible(true);}}
                />
            </div>}

            {badgeDetailsVisible && <div
                className={overlayClassNames.join(' ')}
                onMouseLeave={() => {setBadgeDetailsVisible(false);}}
                onClick={onClickHandler}
            >
                <div className="casino-thumbnail__hover-badge-icon" />
                <div className="casino-thumbnail__hover-badge-text">{badgeText}</div>
            </div>}
        </>
    );
};
